import React from "react";
import { STRINGS } from "../strings";
import { translate } from "../translate";

interface Props {
  currentAnswer: null | undefined | string | string[];
}

const hasAnswer = (
  currentAnswer: string | string[] | null | undefined
): currentAnswer is NonNullable<typeof currentAnswer> => {
  if (currentAnswer === null || currentAnswer === undefined || currentAnswer === "") {
    return false;
  } else if (Array.isArray(currentAnswer) && currentAnswer.length === 0) {
    return false;
  }

  return true;
};

const renderAnswer = (answer: string | string[]) => {
  if (Array.isArray(answer)) {
    return answer.join(", ");
  }
  return answer;
};

const RequiredDocReadonlyAnswer = (props: Props) => {
  return hasAnswer(props.currentAnswer) ? (
    <span>{renderAnswer(props.currentAnswer)}</span>
  ) : (
    <span className="RequiredDocReadonlyAnswer__readonlyUnspecifiedAnswer">
      {translate(STRINGS.UNSPECIFIED)}
    </span>
  );
};

export default React.memo(RequiredDocReadonlyAnswer);
